module.exports = __webpack_public_path__ + "static/media/card-aero.8473d525.png";